import { Col, Row } from "react-grid-system";
import { StyledDialogContent } from "../../components/dialog-content/StyledDialogContent";
import Dialog from "../../components/modal";
import { InputStyle, Label } from "../../components/form/StyledForm";
import Input from "../../components/input";
import Button from "../../components/button";
import { useEffect, useRef, useState } from "react";
import { Colors } from "../../themes";
import Axios from "axios";
import AppConfig from "../../config.js";

const benefitsUrl = AppConfig.BENEFITS_URL;

const PopupModal = ({
  showModalPopup,
  setShowModalPopup,
  editData,
  fetchBanners,
}) => {
  const imageInput = useRef(null);
  const [form, setForm] = useState({
    title: "",
    buttonText: "",
    image: null,
    base64Image: "",
    url: "",
    frequencyDisplay: 0,
  });
  const [error, setError] = useState("");
  const [errorType, setErrorType] = useState("");

  const isEdit = !!editData;

  const onChangeText = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const handleChangeImage = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setForm((prev) => ({ ...prev, image: URL.createObjectURL(file) }));
      setForm((prev) => ({ ...prev, base64Image: reader.result }));
    };
  };

  const validateUrl = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string ✅ fixed
        "(\\#[-a-z\\d_]*)?$",
      "i"
    );
    return !!pattern.test(url);
  };

  const onSubmit = () => {
    if (!form.title) {
      setError("Pop Up Name is required");
      setErrorType("title");
      return;
    }
    if (
      !form.frequencyDisplay ||
      form.frequencyDisplay < 1 ||
      form.frequencyDisplay > 100
    ) {
      if (form.frequencyDisplay < 1) {
        setError("Frequency displayed must be greater than 0 ");
        setErrorType("frequencyDisplay");
        return;
      }
      setError("Frequency display is required");
      setErrorType("frequencyDisplay");
      return;
    }
    if (!form.buttonText) {
      setError("Call To Action Text is required");
      setErrorType("buttonText");
      return;
    }

    if (!form.url || !validateUrl(form.url)) {
      if (!validateUrl(form.url)) {
        setError("URL is invalid");
        setErrorType("url");
        return;
      }
      setError("URL is required");
      setErrorType("url");
      return;
    }

    if (!form.image) {
      setError("Image is required");
      setErrorType("image");
      return;
    }

    if (isEdit) {
      Axios.patch(`${benefitsUrl}/banner/${editData.id}`, {
        ...form,
        type: "POPUP",
      }).then((res) => {
        if (res.data.type !== "ERROR") {
          fetchBanners();
          onCloseModal();
        }
      });
    } else {
      Axios.post(`${benefitsUrl}/banner`, {
        ...form,
        type: "POPUP",
      })
        .then((res) => {
          if (res.data.type === "ERROR") {
            console.log(res.data);
            const desc = res.data.error ? res.data.error : "Error";
            setError(desc);
          } else {
            fetchBanners();
            onCloseModal();
          }
        })
        .catch((err) => {
          setError(err);
        });
    }
  };

  useEffect(() => {
    if (editData) {
      setForm({
        title: editData.title,
        buttonText: editData.buttonText,
        image: editData.imageUrl,
        base64Image: editData.base64Image,
        url: editData.url,
        frequencyDisplay: editData.frequencyDisplay,
      });
    }
  }, [editData]);

  const onCloseModal = () => {
    setShowModalPopup(false);
    onDiscard();
  };

  const onDiscard = () => {
    setForm({
      title: "",
      buttonText: "",
      image: null,
      base64Image: "",
      url: "",
      frequencyDisplay: 0,
    });
  };

  return (
    <Dialog
      isVisible={showModalPopup}
      isClose={onCloseModal}
      title="Pop Up Setup"
      width="76%"
    >
      <StyledDialogContent>
        <Row>
          <Col>
            <Label htmlFor="title">Pop Up Name</Label>
            <Input
              inputProps={{
                id: "title",
                value: form.title,
                name: "title",
                required: true,
                onChange: (e) => onChangeText("title", e.target.value),
              }}
              containerStyle={{
                ...InputStyle,
                backgroundColor: Colors.color3,
                borderColor: Colors.color20,
                marginBottom: "10px",
              }}
            />
            {error && errorType === "title" && (
              <p style={{ color: Colors.color35, marginBottom: "10px" }}>
                {error}
              </p>
            )}
            <Label htmlFor="frequencyDisplay">Frequency Displayed</Label>
            <Input
              inputProps={{
                id: "frequencyDisplay",
                value: form.frequencyDisplay,
                onChange: (e) =>
                  onChangeText("frequencyDisplay", e.target.value),
                type: "number",
                min: "1",
                max: "100",
                required: true,
              }}
              containerStyle={{
                ...InputStyle,
                backgroundColor: Colors.color3,
                borderColor: Colors.color20,
                marginBottom: "10px",
              }}
            />
            {error && errorType === "frequencyDisplay" && (
              <p style={{ color: Colors.color35, marginBottom: "10px" }}>
                {error}
              </p>
            )}
            <Label htmlFor="buttonText">Call To Action Text</Label>
            <Input
              inputProps={{
                id: "buttonText",
                value: form.buttonText,
                onChange: (e) => onChangeText("buttonText", e.target.value),
                required: true,
              }}
              containerStyle={{
                ...InputStyle,
                backgroundColor: Colors.color3,
                borderColor: Colors.color20,
                marginBottom: "10px",
              }}
            />
            {error && errorType === "buttonText" && (
              <p style={{ color: Colors.color35, marginBottom: "10px" }}>
                {error}
              </p>
            )}
            <Label htmlFor="url">URL</Label>
            <Input
              inputProps={{
                id: "url",
                value: form.url,
                onChange: (e) => onChangeText("url", e.target.value),
                required: true,
              }}
              containerStyle={{
                ...InputStyle,
                backgroundColor: Colors.color3,
                borderColor: Colors.color20,
                marginBottom: "10px",
              }}
            />
            {error && errorType === "url" && (
              <p style={{ color: Colors.color35, marginBottom: "10px" }}>
                {error}
              </p>
            )}
          </Col>
          <Col style={{ display: "flex", flexDirection: "column" }}>
            <Label>Pop Up Image</Label>
            <div
              className="image-container"
              style={{
                position: "relative",
                width: "100%",
                height: "370px",
                borderRadius: "10px",
                overflow: "hidden",
                padding: "0px",
              }}
            >
              {form.image && (
                <img
                  src={form.image}
                  alt="banner"
                  className="banner-image"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              )}

              <Button
                text={form.image ? "Change Image" : "Add Image"}
                textStyle={` font-size: 13px; margin: 0; font-weight: 800; paddingLeft: 10px !important; paddingRight: 10px !important; `}
                onClick={() => {
                  imageInput.current.click();
                }}
                buttonStyle={` padding: 10px; position: absolute; top: 50%; transform: translate(-50%, -50%); zIndex: 2; `}
              />

              <input
                type="file"
                style={{ display: "none" }}
                ref={imageInput}
                onChange={handleChangeImage}
                accept="image/*"
                required
              />
            </div>
            {error && errorType === "image" && (
              <p style={{ color: Colors.color35 }}>{error}</p>
            )}
          </Col>
          <div
            className="button-wrapper"
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "end",
              gap: "20px",
            }}
          >
            <div style={{ width: "25%" }}>
              <Button
                text="Discard"
                textColor={Colors.color21}
                buttonStyle={` background: ${Colors.color22}; box-shadow: 3px -3px 10px ${Colors.color3}, 3px 3px 10px ${Colors.color23}; `}
                onClick={onCloseModal}
              />
            </div>
            <div style={{ width: "25%" }}>
              <Button
                text={"Save"}
                buttonStyle={` box-shadow: -3px -3px 10px ${Colors.color3}, 3px 3px 10px ${Colors.color23}; `}
                onClick={onSubmit}
              />
            </div>
          </div>
        </Row>
      </StyledDialogContent>
    </Dialog>
  );
};

export default PopupModal;
